// Module
var code = `<div class="col-sm-24 h-100 sc-px-3 sc-pt-3"> <div id="result-navigation-el" class="sc-bg-300"></div> <div class="row main__body"> <div class="col-sm-24 h-100 d-block sc-mx-0 sc-px-0" ui-view> </div> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/results/results.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;